import React, { useState } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'

const HeaderSettingsType = props => {
  const { classes, themeSettings, onThemeSettingsChange } = props
  // State to track which type is selected (default is 1)
  const [selectedType, setSelectedType] = useState(
    themeSettings?.selectedType || 1,
  )

  // Function to handle type selection
  const handleTypeSelect = type => {
    setSelectedType(type)
    // Call the parent callback to update the theme settings
    if (onThemeSettingsChange) {
      onThemeSettingsChange('selectedType', type)
    }
  }

  // Using direct color values instead of CSS variables
  const positionStyles = {
    selected: {
      border: '1px solid var(--mcg-blue, #015FFB)',
    },
    unselected: {
      border: '1px solid var(--Gray-Lighter, #E5E7EB)',
    },
  }

  const collectionTypesData = [
    {
      image: '/assets/editor-file/landing-page/collection-type-1.png',
      title: 'Default',
      value: 1,
    },
    {
      image: '/assets/editor-file/landing-page/collection-type-2.png',
      title: 'Hero',
      value: 2,
    },
    {
      image: '/assets/editor-file/landing-page/collection-type-3.png',
      title: 'Promo',
      value: 3,
    },
  ]

  return (
    <div className={classes.container}>
      <div className={classes.headerContainer}>
        <Typography className={classes.header}>Header type</Typography>
      </div>
      <div className={classes.typeContainer}>
        {collectionTypesData.map((item, index) => (
          <div className={classes.typeDiv} key={item.value}>
            <div
              className={classes.typeContent}
              onClick={() => handleTypeSelect(item.value)}
              style={
                selectedType === item.value
                  ? positionStyles.selected
                  : positionStyles.unselected
              }
            >
              <img
                src={`/assets/editor-file/landing-page/collection-type-${
                  index + 1
                }.png`}
                alt={`Learning path type ${index + 1}`}
              ></img>
            </div>
            <div className={classes.typeTextDiv}>
              <Typography className={classes.positionText}>
                {item.title}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default withStyles(styles)(HeaderSettingsType)
